// NOTE: https://github.com/date-fns/date-fns/issues/1677

import { format, isToday, isYesterday, isThisWeek, isThisYear } from 'date-fns'

import { ja } from 'date-fns/locale'

const DATE_FORMAT = 'yyyy/M/d'
const DATE_KEBAB_FORMAT = 'yyyy-MM-dd'
const FULL_DATETIME_FORMAT = 'yyyy/M/d H:mm'
const DATE_FORMAT_JA = 'yyyy年M月d日'

export const formatDateTimeForChatMessage = (
  dateOrDateString: Date | string
): string => {
  const date =
    typeof dateOrDateString === 'string'
      ? new Date(dateOrDateString)
      : dateOrDateString

  if (isToday(date)) {
    return format(date, 'H:mm')
  }

  if (isYesterday(date)) {
    return format(date, '昨日 H:mm')
  }

  if (isThisWeek(date)) {
    return format(date, 'EEE H:mm', { locale: ja })
  }

  if (isThisYear(date)) {
    return format(date, 'M/d H:mm', { locale: ja })
  }

  return format(date, FULL_DATETIME_FORMAT, { locale: ja })
}

export const formatDateTime = (date: Date): string =>
  format(date, FULL_DATETIME_FORMAT, { locale: ja })

export const formatDate = (date: Date): string => format(date, DATE_FORMAT)
export const formatKebabDate = (date: Date): string =>
  format(date, DATE_KEBAB_FORMAT)

export const formatDateJa = (date: Date): string =>
  format(date, DATE_FORMAT_JA, { locale: ja })
